export const getErrorMessage = (err: unknown): string => {
  const defaultMessage =
    "Incorrect credentials. Check your login details and try again";
  const detail = (err as any)?.response?.data?.detail;

  if (typeof detail === "string") {
    return detail;
  }

  if (
    Array.isArray(detail) &&
    detail.length > 0 &&
    typeof detail[0]?.msg === "string"
  ) {
    return detail[0].msg;
  }

  return defaultMessage;
};

const parseBlobError = async (blob: Blob): Promise<string | null> => {
  try {
    const text = await blob.text();
    const json = JSON.parse(text);
    return json.detail;
  } catch {
    return null;
  }
};

export const getErrorMessageFromResponse = (err: unknown): string => {
  const defaultMessage = "An error occurred. Please try again later.";
  const detail = (err as any)?.response?.data?.detail;

  if (typeof detail === "string") {
    return detail;
  }

  if (
    Array.isArray(detail) &&
    detail.length > 0 &&
    typeof detail[0]?.msg === "string"
  ) {
    return detail[0].msg;
  }

  return defaultMessage;
};

export const getErrorMessageFromBlobResponse = async (
  err: unknown,
): Promise<string> => {
  const defaultMessage = "An error occurred. Please try again later.";
  const detail = (err as any)?.response?.data?.detail || (err as any)?.detail;

  const responseData = (err as any)?.response?.data;
  if (responseData instanceof Blob) {
    const blobDetail = await parseBlobError(responseData);
    if (blobDetail) {
      return blobDetail;
    }

    return defaultMessage;
  }

  if (typeof detail === "string") {
    return detail;
  }

  if (
    Array.isArray(detail) &&
    detail.length > 0 &&
    typeof detail[0]?.msg === "string"
  ) {
    return detail[0].msg;
  }

  return defaultMessage;
};
